var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relatorio-cell"},[_c('div',{class:_vm.classStyle},[_c('div',{staticClass:"icon"},[_c('u-icon',{attrs:{"name":_vm.icon,"type":_vm.iconType,"icon-style":_vm.iconStyle}})],1),_c('div',{staticClass:"rtitle"},[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }